<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-23 17:32:04
-->
<template>
    <div class="add-danwei">
        <el-form
            ref="ruleForm"
            :model="viewData"
            :rules="rules"
            label-width="100px"
        >
            <el-form-item label="审核结果" prop="review_status">
                <el-select
                    v-model="viewData.review_status"
                    clearable
                    filterable
                    placeholder="请选择审核结果"
                >
                    <el-option
                        v-for="item in optionList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" :rows="3" v-model="viewData.remark" />
            </el-form-item>
        </el-form>
        <div class="fix-fotter">
            <el-button
                style="
                    min-width: 117px;
                    background: #1067e0;
                    font-size: 16px;
                    border-color: #1067e0;
                "
                size="mini"
                type="primary"
                @click="tijiao('ruleForm')"
                >提交</el-button
            >
        </div>
    </div>
</template>

<script>
import fetch from "@/api/tianzheng/car";
export default {
    data() {
        return {
            optionList: [
                {
                    name: "通过",
                    id: "1",
                },
                {
                    name: "驳回",
                    id: "2",
                },
            ],
            viewData: {
                id: "",
                review_status: "",
                remark: "",
            },
            rules: {
                review_status: [
                    {
                        required: true,
                        message: "请选择审核结果",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {},
    created() {
    },
    methods: {
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            let that = this;
            this.viewData = {
                id: "",
                review_status: "",
                remark: "",
            };
            this.resetForm()
            if (obj.id) {
                // 编辑
                that.viewData.id = obj.id;
            } else {
                // 新增
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc:
         */
        tijiao(formName) {
            let that = this;
            console.log(this.viewData);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.viewData.id) {
                        // 编辑
                        fetch.review(this.viewData).then((res) => {
                            if (res.code == 200) {
                                that.$message.success(res.message);
                                that.$emit("onUpdateDrawer", 1);
                            } else {
                                that.$message.error(res.message);
                                that.$emit("onUpdateDrawer", -1);
                            }
                        });
                    } else {
                        // 新增
                        // fetch.create(this.viewData).then((res) => {
                        //     if (res.code == 200) {
                        //         that.$message.success(res.message);
                        //         that.$emit("onUpdateDrawer", 1);
                        //     } else {
                        //         that.$message.error(res.message);
                        //         that.$emit("onUpdateDrawer", -1);
                        //     }
                        // });
                    }
                } else {
                    this.$message.warning(this.$t("form.verifyMsg"));
                }
            });
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            this.$refs["ruleForm"].resetFields();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
